import React, {MouseEvent} from 'react';
import {ChatBoxButton} from '../../../../../../components/Common/Chatbox/ChatBox';
import {AutomationChoose} from '../../../../reducer/model';
import styles from './styles.module.scss';

type Props = {
    activeAction: string | number;
    handleClick: (e: MouseEvent<HTMLButtonElement>) => void;
    data: Array<AutomationChoose>;
    tooltipPortalId?: string;
};

export const SettingsActions = (props: Props) => {
    const {handleClick, activeAction, data, tooltipPortalId} = props;

    return (
        <div className={styles.component}>
            {data.map(item => {
                const itemTooltip = (item?.data as any)?.tooltip;

                return (
                    <ChatBoxButton
                        key={`${item.value}`}
                        value={item.value as string | number}
                        icon={item.icon}
                        text={item.label}
                        onClick={handleClick}
                        active={activeAction === item.value}
                        disabled={item.disabled}
                        wrapClassName={styles.item}
                        tooltipProps={{
                            portalId: tooltipPortalId,
                            tooltip: itemTooltip,
                            tooltipOffset: 8,
                            position: 'top'
                        }}
                    />
                );
            })}
        </div>
    );
};
